import reducer from './reducers';

import * as authOperations from './operations';

export {
    authOperations
};

export default reducer;
